/**
 * Standalone Payroll Deductions Report page.
 *
 * For users with the can_view_deductions permission (payroll staff) who
 * should run the employee deduction report without full admin access.
 * Reuses the exact report component from the admin Reports page.
 */

import { useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../components/auth';
import { EmployeeListReport, EmployeeHistoryReport } from './admin/ReportsPage';

export function DeductionsPage() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState<'deductions' | 'history'>('deductions');

  if (!user?.canViewDeductions && !user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-hmh-blue shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-white">Payroll Deductions Report</h1>
            <p className="text-white/80">Hood Memorial Hospital Lunch Ordering System</p>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="px-4 py-2 text-sm font-medium text-hmh-blue bg-white rounded-lg hover:bg-gray-100 transition-colors">Home</Link>
            <span className="text-white">{user?.fullName}</span>
            <button onClick={logout} className="px-4 py-2 text-sm font-medium text-hmh-blue bg-white rounded-lg hover:bg-gray-100 transition-colors">Sign Out</button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-lg">
          <div className="border-b border-gray-200 flex">
            {([['deductions', 'Deductions Report'], ['history', 'Employee History']] as const).map(([key, label]) => (
              <button
                key={key}
                onClick={() => setTab(key)}
                className={`flex-1 py-4 px-6 text-center font-medium text-sm border-b-2 transition-colors ${
                  tab === key
                    ? 'border-blue-500 text-blue-600 bg-blue-50'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
          <div className="p-6">
            {tab === 'deductions' ? <EmployeeListReport /> : <EmployeeHistoryReport />}
          </div>
        </div>
      </main>
    </div>
  );
}
